export const paymentRequestStatusColors = {
  "Sent": "blue",
  "Created": "blue",
  "Opened": "blue",
  "Delivered": "blue",
  "Delivery failed": "red",
  "Processing": "blue",
  "Attempt failed": "red",
  "Reminder sent": "yellow",
  "Paid": "green",
  "Part-paid": "green",
  "Cancelled": "zinc",
  "Expired": "zinc",
  "Part-refund": "zinc",
  "Refunded": "zinc",
  "Matched": "yellow",
  "Planned": "yellow",
  "Actioned": "green",
  "Actioned manually": "green",
  "InTransit": "yellow",
  "No match found": "red",
  "Failed": "red",
}

export const transactionStatusColors = {
  "Paid": "green",
  "Refunded": "zinc",
  "Part-refund": "zinc",
  "Refund failed": "red",
  "Succeeded": "green",
  "Failed": "red",
  "Pending": "blue",
  "Cancelled": "red",
  "Awaiting authorisation": "yellow",
}

// Normalise the various refund status conventions (unified "Succeeded"/"Failed"
// and the legacy open-banking "PaymentSucceeded"/"Processing" names) onto the
// display labels used by transactionStatusColors.
export const refundStatusLabel = (status) =>
  ({
    Succeeded: "Refunded",
    PaymentSucceeded: "Refunded",
    Pending: "Pending",
    Processing: "Pending",
    Failed: "Failed",
    PaymentFailed: "Failed",
    Initialized: "Awaiting authorisation",
    Cancelled: "Cancelled",
  })[status] ?? status;